import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 43.3 14",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFF",
			d: "M43.3,13.8h-3.3c-0.1-0.6-0.2-1.1-0.3-1.7c0-0.2-0.1-0.3-0.4-0.3c-1.3,0-2.6,0-3.9,0c-0.2,0-0.3,0.1-0.3,0.2c-0.2,0.5-0.4,1.1-0.6,1.6c0,0.1-0.1,0.2-0.2,0.2c-1.2,0-2.4,0-3.6,0c0.2-0.5,0.4-1,0.6-1.5l4.6-10.9c0.2-0.7,0.9-1.2,1.7-1.1h2.9c0.1,0.4,0.2,0.9,0.3,1.3L43,12.3c0.1,0.5,0.2,0.9,0.3,1.4L43.3,13.8z M39.1,9l-1-5l0,0l-1.8,5H39.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFF",
			d: "M29.1,0c0.4,0.1,0.9,0.1,1.3,0.2c0.4,0.1,0.8,0.2,1.2,0.3L31,3.4c-0.5-0.2-1.1-0.3-1.6-0.5c-0.7-0.2-1.5-0.2-2.2,0c-0.3,0.1-0.6,0.2-0.8,0.4c-0.3,0.3-0.4,0.7-0.2,1.1c0,0.1,0.1,0.1,0.1,0.1c0.3,0.2,0.6,0.5,0.9,0.6c0.7,0.4,1.5,0.8,2.2,1.3c0.8,0.5,1.4,1.3,1.5,2.3c0.3,1.7-0.5,3.3-1.9,4.2c-0.9,0.6-2,0.9-3.1,1c-1.5,0.1-3.1,0-4.5-0.5c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1-0.1l0.6-3c0.3,0.1,0.5,0.2,0.7,0.3c1.1,0.5,2.4,0.6,3.6,0.4c0.3-0.1,0.6-0.2,0.9-0.4c0.5-0.3,0.6-0.9,0.3-1.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4-0.3-0.8-0.6-1.2-0.8c-0.6-0.4-1.3-0.7-1.9-1.1c-0.8-0.5-1.3-1.3-1.4-2.3c-0.2-1.4,0.4-2.7,1.5-3.6c1-0.8,2.1-1.2,3.4-1.3c0.1,0,0.1,0,0.2,0L29.1,0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFF",
			d: "M16.4,0.3c-0.2,0.4-0.4,0.9-0.5,1.3c-1.7,4-3.4,8-5,12c0,0.2-0.2,0.3-0.4,0.2c-1.1,0-2.1,0-3.2,0c-0.2,0-0.3-0.1-0.3-0.3C6.1,10,5.2,6.5,4.3,3C4.2,2.4,3.7,1.9,3.2,1.7c-1-0.4-2-0.7-3-1L0,0.6c0-0.4,0-0.4,0.4-0.4H6c0.8,0,1.6,0.6,1.7,1.4C8.1,4.1,8.6,6.6,9,9c0,0.1,0,0.2,0.1,0.4c0-0.1,0.1-0.1,0.1-0.2c1.2-2.9,2.3-5.8,3.4-8.7c0-0.1,0.2-0.2,0.3-0.2c1.1,0,2.2,0,3.2,0C16.3,0.2,16.3,0.2,16.4,0.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFF",
			d: "M15,13.8l2.9-13.5h3.5l-0.4,2c-0.8,3.7-1.6,7.4-2.4,11.2c-0.1,0.3-0.1,0.3-0.4,0.3c-1,0-1.9,0-2.9,0L15,13.8z"
		})
	]
});
export { SvgVisa as ReactComponent };
